module.exports = __webpack_public_path__ + "media/src/ui/icons/pdf_new-c8577be53fa97a993b93f41adf8d0ad1.svg";